import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-226" data-mp="1mmh6abszb4gw">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-227" data-mp="1hph2y8nikfth">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-228" data-mp="ty1vk1gvr8bd">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-229" data-mp="u0xvtwg7a92z">
            Descoperă pachetul complet <em className="text-red-300" data-id="element-230" data-mp="13wrelxkiiyt7">TEHNOLOGIE GATA DE PREDAT™</em>
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-231" data-mp="13uoh6sh163eg">
            Un an școlar întreg de ore de tehnologie, gata pregătit în doar 5 minute.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-232" data-mp="2feao27oory07" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-233" data-mp="pkh6baejmufo">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-234" data-mp="uhqs8g2q4nyr">Pachetul complet conține</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-235" data-mp="zjpwrta79qxa">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-236" data-mp="13j74yuh0h265">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-237" data-mp="6uiqg84i7x1h">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-238" data-mp="btlw9usb67ai" />
                </span>
                <span data-id="element-239" data-mp="ft4gspg7wgct">
                  <span className="block font-medium leading-snug" data-id="element-240" data-mp="fskyv8qkhrys">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-241" data-mp="kn8ojaxb4sey">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-242" data-mp="3o960g4gvdirv">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-243" data-mp="vde6x1n3tw42">Preț de lansare</p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-244" data-mp="qejoi0t1u9kh">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-245" data-mp="107if1o83wa6q">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="cho2z8vm2pnj" />
            Plată unică. Fără abonament.
          </p>

          <CtaButton label="Vreau pachetul complet acum" className="mt-8 w-full" data-id="element-247" data-mp="7jwbuh2sj7ke" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-248" data-mp="lj4c7daowlq6">
            {offerIncludes.map(item => <li key={item} data-id="element-249" data-mp="1wwq0kw8q6jan">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}